import React from 'react'

const TableElement = (props) => {


    return (<div>Table{JSON.stringify(props.data)}</div>)
}

export default TableElement;
